import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "composite-icon position-relative" }

import { computed } from 'vue';
import CompositeIconInfo from "@/guiide/ts/components/compositeIconInfo.ts";


export default /*@__PURE__*/_defineComponent({
  __name: 'CompositeIcon',
  props: {
    icons: { type: Array<CompositeIconInfo>, required: true }
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.icons, (info, i) => {
      return (_openBlock(), _createElementBlock("i", {
        key: i,
        class: _normalizeClass(["bi", info.icon]),
        style: _normalizeStyle({
        fontSize: info.size,
        top:      info.top,
        left:     info.left
      })
      }, null, 6))
    }), 128))
  ]))
}
}

})